import NetworkRequestConfiguration from '@root/core/src/networking/network-request-configuration';

export const generateAndSendOtpConfiguration = ({ phoneNumber }) => {
  return new NetworkRequestConfiguration({
    endpoint: 'multifactor_authentication/generate_and_send_otp',
    method: NetworkRequestConfiguration.Methods.POST,
    bodyParameters: {
      phoneNumber,
    },
    successCodes: [200],
    errorCodes: [401],
  });
};

export const verifyOtpConfiguration = ({ phoneNumber, otpToken }) => {
  return new NetworkRequestConfiguration({
    endpoint: 'multifactor_authentication/enable_multifactor_authentication',
    method: NetworkRequestConfiguration.Methods.POST,
    bodyParameters: {
      phoneNumber,
      otpToken,
    },
    successCodes: [200],
    errorCodes: [401],
  });
};
